module.exports = __webpack_public_path__ + "static/media/cap2-02-mob.82d8cae9.png";